import React, { useMemo } from 'react';
import { ModelContent } from 'pages/Home/ModelContent';
import { useDispatch, useSelector } from 'react-redux';
import { getTeamModels } from 'store/actions/userData';
import { getTeamData } from 'store/actions/teamData';
import { ModelContext } from 'pages/Home/ModelContext';
import { useCookies } from 'react-cookie';
import { Navigate } from 'react-router-dom';

const TeamModels = () => {
    const dispatch = useDispatch();
    const [ cookies ] = useCookies([ 'userAuth' ]);
    const token = cookies.archvision_token;
    const userDataStore = useSelector(state => state.userData);
    const teamModels = useMemo(() => userDataStore.teamModels, [ userDataStore.teamModels ]);
    const selectedTeamId = useMemo(() => userDataStore.selectedTeamId, [ userDataStore.selectedTeamId ]);

    if (userDataStore.data.teams && Array.isArray(userDataStore.data.teams) && userDataStore.data.teams.length > 0) {
        const searchTeamId = selectedTeamId || userDataStore.data.teams[0].teamId;
        const getModels = teamId => { dispatch(getTeamModels({ token, teamId: teamId || searchTeamId })); };
        const getTeam = teamId => { dispatch(getTeamData(token, teamId || searchTeamId)); };

        const contextValue = {
            getModels: getModels,
            getTeamData: getTeam,
            workingData: teamModels,
            pageTitle: 'Team Models',
            sortingOptions: [ 'ascending', 'descending', 'oldest first', 'newest first' ],
            searchParam: 'categories',
            searchCategoryParam: 'search_category',
            searchSubcategoryParam: 'search_subcategory',
        };

        return (
            <ModelContext.Provider value={contextValue}>
                <ModelContent />
            </ModelContext.Provider>
        );
    }
    return <Navigate to={'/welcome'} />;

};

export { TeamModels };
